import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "./../images/wara logo1.png";
import "./Header.css";
function Header() {
  // const handleheader = () => {};
  const [ismobile, setIsmobile] = useState(false);
  const [activeTab, setActiveTab] = useState("home"); // Initial state
const navigate=useNavigate()
  const handleTabClick = (tabName,link) => {
    setActiveTab(tabName);
    navigate(link)
  };

  return (
    <div
      className={
        ismobile
          ? "px-3 py-3 block  header text-black uppercase  text-4 font-bold  bg items-center rounded fixed w-full shadow-lg z-10 font-play"
          : "px-3 py-3 flex  justify-between md:justify-around header text-black uppercase  text-4 font-bold  bg items-center rounded fixed w-full shadow-lg z-10 font-play"
      }
    >
      <div className="flex  w-full justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-8 h-8  ml-2 lg:hidden"
          onClick={() => setIsmobile(!ismobile)}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
        <Link
          to="/"
          className="title font-xbold  font-play uppercase"
          onClick={() => handleTabClick("home")}
        >
          <img src={logo} alt="" className="w-32 round-1/2" />
        </Link>
      </div>
      <ul
        className={
          ismobile
            ? "block  mt-4 text-sm"
            : "hidden w-0 md:w-full lg:flex items-center text-sm md:text-base"
        }
        onClick={() => setIsmobile(false)}
      >
        <li
          onClick={() => handleTabClick("home", "/")}
          className={
            activeTab === "home"
              ? "m-4 text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
              : "m-4 hover:text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
          }
        >
          <p>Home</p>
        </li>
        <li
          onClick={() => handleTabClick("about", "/About")}
          className={
            activeTab === "about"
              ? "m-4 text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
              : "m-4 hover:text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
          }
        >
          <p>About</p>
        </li>
        <li
          onClick={() => handleTabClick("services", "/Service")}
          className={
            activeTab === "services"
              ? "m-4 text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
              : "m-4 hover:text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
          }
        >
          <p>Services</p>
        </li>

        <li
          onClick={() => handleTabClick("portifolio", "/Projects")}
          className={
            activeTab === "portifolio"
              ? "m-4 text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
              : "m-4 hover:text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
          }
        >
          <p>portifolio</p>
        </li>

        <li
          onClick={() => handleTabClick("blog", "/blog")}
          className={
            activeTab === "blog"
              ? "m-4 text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
              : "m-4 hover:text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
          }
        >
          <p>Blog</p>
        </li>
        <li
          onClick={() => handleTabClick("contact","/Contact")}
          className={
            activeTab === "contact"
              ? "m-4 text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
              : "m-4 hover:text-[#f0b134]  py-1 px-4 rounded-full font-play cursor-pointer"
          }
        >
          <p>Contact</p>
        </li>
        <li className="phone rounded-full px-4 py-1 w-full  text-white bg-black">
          <Link
            to={`tel://0966438359`}
            target="_blank"
            className="flex gap-1 w-full"
          >
            <span class=" me-3 [&>svg]:h-5 [&>svg]:w-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="fill-black dark:fill-white "
              >
                <path
                  fill-rule="evenodd"
                  d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            0966438359
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Header;
